export const osnPlayIcon = {
  // eslint-disable-next-line max-len
  data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.7519 11.168L8.5547 3.03647C7.89015 2.59343 7 3.06982 7 3.86852L7 20.1315C7 20.9302 7.89014 21.4066 8.5547 20.9635L20.7519 12.8321C21.3457 12.4362 21.3457 11.5638 20.7519 11.168Z" fill="currentColor"/></svg>`,
  name: 'play',
};
